import { Api } from './fetch';

type MetaRes<T extends object> = {
  id: string;
  key: string;
  value: T;
  createdAt: Date;
};

export class AppNet {
  static app = {
    versions: () => Api.get<'app', 'version'>('/versions'),
    healthCheck: () => Api.get<'app', 'allServiceHealthCheck'>('/healthcheck'),
    searchKeys: () => Api.get<'auth', 'searchKeys'>('/auth/search-keys'),
  };
  static flags = {
    get: () => Api.get<'flag', 'get'>('/flags'),
  };
  static meta = {
    read: <T extends object>(key: string) => Api.get<'meta', 'read', MetaRes<T>>(`/meta/:key`, { params: { key } }),
    upsert: <T extends object>(key: string, value: T) =>
      Api.post<'meta', 'upsert', MetaRes<T>>(`/meta/:key`, { params: { key }, body: { value } }),
  };
}
